/* ---------------------------------------------------------------------
   Minimalist logo add-on on the product page (owner, 17 Oct 2026).
   Markup and the why: snippets/gc-logo-addon.liquid.

   1. The square ticks and unticks here (gc-product-upsell.js leaves
      [data-gc-addon-own] alone). Nothing goes into the cart on the tick:
      this add-on belongs to one case, so it travels with that case.
   2. The case shows the choice. Ticked, every gallery photo and thumbnail
      that has a logo-free twin (the map from snippets/gc-logo-free-map)
      shows the twin, zoom included; unticked, the originals come back.
      The row's own thumbnail is always the logo-free twin of the colour on
      screen, so the option shows what it does before anyone ticks it.
   3. The add. When the page adds one of THIS product's variants while the
      square is ticked, the $25 line goes in first (XHR, {_logo_link}), then
      the case itself with "Logo: Minimalist" and the same id as _logo_id.
      Fee first on purpose: the "Check your order" panel redirects to
      checkout the moment the case shows up in the cart, and the fee must
      already be there. If the case is refused, the fee is taken back out.
      assets/gc-logo-sync.js keeps the pair together afterwards.
   4. The spot on the photo (owner, 17 Oct 2026). On every gallery photo
      whose wordmark position is measured, the indicator of
      assets/gc-logo-spot.js: "Logo inside +$25" under the gold wordmark,
      and, ticked, a see-through "Logo inside" chip on the clean leather
      (Oct 2026: it replaced "Remove logo" and "Logo pressed inside |
      Restore"). It is the same tick: this row owns window.GCLogo, the
      page's one "logo inside" state, and the spots press the square.
   5. The initials previews (owner, 17 Oct 2026). The personalize drawer's
      picture, its colour swatches and saved items, and the "Check your
      order" thumbnail show the case as the square has it: the logo-free
      twin while ticked, in any colour.
   6. "Add all to cart" in the personalize drawer (Oct 2026: "Should the
      drawer's version carry it too? - yes"). personalize-drawer.js hands
      its batch to GCLogo.tagItems() before it sends it; while the square
      is ticked every case of this product in it gets its own $25 line.
   --------------------------------------------------------------------- */
(function () {
  var row = document.querySelector('[data-gc-logo-addon]');
  if (!row || row.__gcLogo) return;
  row.__gcLogo = true;
  var cfg;
  try { cfg = JSON.parse(row.querySelector('[data-gc-logo-config]').textContent); } catch (e) { return; }
  var MAP = cfg.map || {};
  var VARIANTS = Object.create(null);
  (cfg.variants || []).forEach(function (v) { VARIANTS[String(v)] = true; });
  var box = row.querySelector('[data-gc-addon-check]');
  var thumb = row.querySelector('[data-gc-logo-thumb]');
  var on = false;
  /* assets/gc-logo-spot.js, loaded just before this file (snippets/gc-logo-spot-kit.liquid); the row
     works without it, only the spots on the photos would be missing */
  var G = window.GCLogo, SPOT = window.GCLogoSpot;
  if (G) G.register(cfg.product, MAP);

  function sized(url, w) { return url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
  function abs(url) { return url.indexOf('//') === 0 ? 'https:' + url : url; }
  /* map entries are {u, x, y, w, r} (url + where the wordmark sits); a bare url string is accepted too */
  function twin(mediaId) {
    var e = MAP[String(mediaId)];
    var u = typeof e === 'string' ? e : (e && e.u);
    return u ? abs(u) : '';
  }

  /* ---------------------------------------------------------- the photos */
  var ATTRS = ['src', 'srcset', 'data-zoom-src', 'data-original-src'];
  /* .Product__SlideshowThumbnail: the thumbnail strips under the gallery (desktop and mobile nav), every
     colour's photos in one row, shown and hidden per colour. Oct 2026: they kept the gold-logo photo under a
     logo-free slide. All of them are in the page from the start, so a tick (and paint() after a colour
     change) reaches every one. */
  function photos() {
    return [].slice.call(document.querySelectorAll(
      '.Product__SlideItem[data-media-id] img, .Product__SlideshowNavImage[data-media-id] img, .Product__SlideshowThumbnail[data-media-id] img'));
  }
  function mediaOf(img) {
    var host = img.closest('[data-media-id]');
    return host ? host.getAttribute('data-media-id') : '';
  }
  function swap(img, minimal) {
    var url = twin(mediaOf(img));
    if (!url) return;
    if (minimal) {
      if (!img.hasAttribute('data-gc-logo-was')) {
        var was = {};
        ATTRS.forEach(function (a) { if (img.hasAttribute(a)) was[a] = img.getAttribute(a); });
        img.setAttribute('data-gc-logo-was', JSON.stringify(was));
      }
      /* each thumbnail at the size the theme asked for: the stacked gallery's nav at width 160, the strips
         square-cropped at 150 (image_url: width: 150, height: 150); data-gc-logo-was brings either back */
      var strip = !!img.closest('.Product__SlideshowThumbnail');
      var isThumb = strip || !!img.closest('.Product__SlideshowNavImage');
      /* only what differs (paint runs again after every variant change): setting a src again reloads
         it, and the personalize drawer copies every gallery src that is set (holdPreviews, below) */
      if (img.hasAttribute('srcset')) put(img, 'srcset', [1200, 1600, 2048].map(function (w) { return sized(url, w) + ' ' + w + 'w'; }).join(', '));
      put(img, 'src', strip ? sized(url, 150) + '&height=150&crop=center' : sized(url, isThumb ? 160 : 1600));
      if (img.hasAttribute('data-zoom-src')) put(img, 'data-zoom-src', sized(url, 4096));
      if (img.hasAttribute('data-original-src')) put(img, 'data-original-src', sized(url, 4096));
    } else if (img.hasAttribute('data-gc-logo-was')) {
      var w0 = {};
      try { w0 = JSON.parse(img.getAttribute('data-gc-logo-was')); } catch (e) {}
      ATTRS.forEach(function (a) { if (w0[a] != null) img.setAttribute(a, w0[a]); });
      img.removeAttribute('data-gc-logo-was');
    }
  }
  function put(el, a, v) { if (el.getAttribute(a) !== v) el.setAttribute(a, v); }
  function paint() {
    holdPreviews(); /* the drawer keeps its own colour's photo through the swap (below) */
    photos().forEach(function (img) { swap(img, on); });
  }
  function setThumb(mediaId) {
    var url = twin(mediaId);
    if (thumb && url) thumb.style.backgroundImage = "url('" + sized(url, 200) + "')";
  }
  setThumb(cfg.init);

  document.addEventListener('variant:changed', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (v && v.featured_media) setThumb(v.featured_media.id);
    if (on) setTimeout(paint, 60);
    setTimeout(mountSpots, 80); /* a gallery rebuilt for the new variant gets its spots back */
  });

  function set(next) {
    on = !!next;
    box.setAttribute('aria-checked', on ? 'true' : 'false');
    document.documentElement.classList.toggle('gc-logo-minimal', on);
    paint();
    previews();
    if (G) G.changed(); /* every spot on the page, and whoever listens (GCLogo.onChange) */
  }
  /* own clicks and keys, capture phase like the generic squares */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gc-addon-own]');
    if (!b || b !== box) return;
    e.preventDefault();
    e.stopPropagation();
    set(!on);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Enter' && e.key !== 'Spacebar') return;
    var b = e.target.closest && e.target.closest('[data-gc-addon-own]');
    if (!b || b !== box) return;
    e.preventDefault();
    set(!on);
  }, true);

  /* ---------------------------------------------------------- the spots on the photos
     Owner, 17 Oct 2026: "a small indicator on the image itself where the logo is", the way the initials
     are added from the photo (gcpx-pdpspot). Every gallery slide whose photo has a measured wordmark
     (x, y, w, r in the map: % of the photo, degrees) gets the indicator of assets/gc-logo-spot.js. It keeps
     no state of its own: this row owns GCLogo, so a press on a spot is box.click(), exactly a tick on the
     square, and the photos, the row, the "Check your order" panel, the analytics and the add all follow one
     and the same tick. The price is read from this row, so the spot always shows what the row shows.
     Drawn from here rather than in Liquid: the map is only known after the gallery has been rendered, and a
     copy of the section fetched into another page (the quick-buy drawer) has no script behind it, so it
     never shows a spot that does nothing. Photos without a measured position get no spot rather than a
     misplaced one. */
  var priceEl = row.querySelector('.gc-sp-addon__price .Price');
  function price() { return priceEl ? String(priceEl.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  if (G) G.own({ isOn: function () { return on; }, toggle: function () { box.click(); }, tag: tagItems });

  function spotAt(mediaId) {
    var e = MAP[String(mediaId)];
    if (!e || typeof e !== 'object') return null;
    var x = parseFloat(e.x), y = parseFloat(e.y), w = parseFloat(e.w), r = parseFloat(e.r) || 0;
    return isFinite(x) && isFinite(y) && w > 0 ? { x: x, y: y, w: w, r: r } : null;
  }
  /* one per photo; safe to call again (a variant change): it only adds what is missing */
  function mountSpots() {
    if (!SPOT) return;
    [].forEach.call(document.querySelectorAll('.Product__SlideItem--image[data-media-id]'), function (slide) {
      var fig = slide.querySelector('figure');
      var img = fig && fig.querySelector('img');
      var p = spotAt(slide.getAttribute('data-media-id'));
      if (!img || !p || fig.querySelector('[data-gc-logo-spot]')) return;
      fig.__gcLogoSpot = SPOT.mount(fig, img, p, { price: price });
    });
  }
  /* a slide coming on screen is refitted as it does (the gallery box may have changed under it while it was
     off screen) */
  var slideshow = document.querySelector('.Product__Slideshow');
  if (slideshow && typeof MutationObserver === 'function') {
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        var t = m.target;
        if (t.classList && t.classList.contains('Product__SlideItem') && t.classList.contains('is-selected')) {
          var fig = t.querySelector('figure');
          if (fig && fig.__gcLogoSpot) fig.__gcLogoSpot.refresh();
        }
      });
    }).observe(slideshow, { attributes: true, attributeFilter: ['class'], subtree: true });
  }
  if (priceEl && SPOT && typeof MutationObserver === 'function') {
    new MutationObserver(function () { SPOT.refreshAll(); }).observe(priceEl, { childList: true, characterData: true, subtree: true });
  }
  mountSpots();

  /* ---------------------------------------------------------- the initials previews
     Owner, 17 Oct 2026: with the Minimalist logo ticked, "Add initials" (the personalize drawer,
     snippets/personalize-drawer.liquid) still showed the case WITH the gold logo. personalize-drawer.js
     writes its picture from half a dozen places (the colour swatch as a _600x600_crop_center file, the
     variant's photo at width=600, the gallery, a saved item), and the "Check your order" panel
     (gcx-pdpcheck) shows the variant's photo. Rather than teach every writer, each of those pictures is
     watched here and follows the square: a photo of this case that has a logo-free twin shows the twin
     while ticked and the original when not, at the size it was asked for, whatever colour the drawer
     moves to. Photos are matched by file name (cfg.media: media id -> original file, for the photos in
     the map, from Liquid), so neither a _600x600_crop_center suffix nor a width= gets in the way. */
  /* The drawer's colour swatches too (the same photos at 100px), so the colours offered next to a logo-free
     preview are logo-free as well, and its saved personalizations: "Add all to cart" carries the Minimalist
     logo for this product's cases while the square is ticked (6., below), so they show what it adds (Oct 2026;
     until then they always showed the gold logo, as "Add all" added them without it).
     personalize-drawer.js builds both inside the drawer, on every opening and after every save, so the
     drawer is watched deep (watchDrawer, below). */
  var PREVIEWS = '[data-personalize-image], .gcx-check__img, .drawer-variant-swatch img, .personalize-drawer__saved-item-image';
  var DRAWER = '[data-personalize-drawer]';
  var BY_FILE = Object.create(null); /* file name -> [media id, is it the twin] */
  function fileOf(url) {
    var f = String(url || '').split(/[?#]/)[0];
    f = f.slice(f.lastIndexOf('/') + 1).replace(/\.(jpe?g|png|webp|avif|gif)$/i, '');
    return f.replace(/_(\d+x\d*|x\d+)(_crop_[a-z]+)?(@\dx)?$/i, '').toLowerCase();
  }
  var ORIG = cfg.media || {};
  /* a photo the config does not name is taken from the gallery as it was rendered (nothing is swapped yet) */
  [].forEach.call(document.querySelectorAll('.Product__SlideItem[data-media-id] img'), function (img) {
    var id = mediaOf(img), src = img.getAttribute('src');
    if (!ORIG[id] && twin(id) && src) ORIG[id] = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
  });
  Object.keys(ORIG).forEach(function (id) {
    if (!twin(id) || !ORIG[id]) return;
    BY_FILE[fileOf(ORIG[id])] = [id, false];
    BY_FILE[fileOf(twin(id))] = [id, true];
  });
  function widthOf(url) {
    var m = /[?&]width=(\d+)/.exec(url) || /_(\d+)x\d*(_crop_[a-z]+)?\.[a-z]+(\?|$)/i.exec(url);
    return m ? +m[1] : 600;
  }
  /* the same photo, as the square has it */
  function asTicked(src) {
    var hit = BY_FILE[fileOf(src)];
    if (!hit || hit[1] === on) return src;
    return sized(on ? twin(hit[0]) : abs(String(ORIG[hit[0]])), widthOf(src));
  }
  function keepTicked(img) {
    var src = img.getAttribute('src') || '';
    var want = src && asTicked(src);
    if (want && want !== src) img.setAttribute('src', want);
  }
  function follow(img) {
    if (img.__gcLogoFollow) return;
    img.__gcLogoFollow = true;
    /* the setAttribute below comes back here once and is then left alone (it already is as ticked) */
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () { keepTicked(img); }).observe(img, { attributes: true, attributeFilter: ['src'] });
    }
  }
  function previews() {
    [].forEach.call(document.querySelectorAll(PREVIEWS), function (img) { follow(img); keepTicked(img); });
  }
  /* personalize-drawer.js copies each gallery src that changes into its picture and its button's
     data-product-image, the last one winning, so a gallery swap (paint) would hand it whichever slide
     came last: another colour. What both showed before the swap is put back once that has run, as the
     square has it. */
  function holdPreviews() {
    var btn = document.querySelector('[data-open-personalize-drawer]');
    var img = document.querySelector('[data-personalize-image]');
    var b0 = btn && btn.getAttribute('data-product-image'), i0 = img && img.getAttribute('src');
    setTimeout(function () {
      if (b0 && btn.getAttribute('data-product-image') !== b0) btn.setAttribute('data-product-image', asTicked(b0));
      if (i0 && img.getAttribute('src') !== i0) img.setAttribute('src', asTicked(i0));
    }, 0);
  }
  /* the drawer is built from its <template> at DOMContentLoaded and the panel is built on each press,
     both straight into <body>: a picture is followed from the moment it arrives, before it is painted */
  function grab(ms) {
    ms.forEach(function (m) {
      [].forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        var found = [].slice.call(n.querySelectorAll(PREVIEWS));
        if (n.matches(PREVIEWS)) found.push(n);
        found.forEach(function (img) { follow(img); keepTicked(img); });
        watchDrawer(n.matches(DRAWER) ? n : n.querySelector(DRAWER));
      });
    });
  }
  /* inside the drawer, at any depth: the swatches and the saved list are built there long after the
     drawer itself arrived in <body> */
  function watchDrawer(d) {
    if (!d || d.__gcLogoWatch || typeof MutationObserver !== 'function') return;
    d.__gcLogoWatch = true;
    new MutationObserver(grab).observe(d, { childList: true, subtree: true });
  }
  if (typeof MutationObserver === 'function') new MutationObserver(grab).observe(document.body, { childList: true });
  watchDrawer(document.querySelector(DRAWER));
  previews();

  /* ---------------------------------------------------------- the add */
  function newId() { return 'lg' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
  function xhr(url, body) {
    return new Promise(function (resolve) {
      var x = new XMLHttpRequest();
      x.open('POST', url, true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onloadend = function () {
        var j = null;
        try { j = JSON.parse(x.responseText); } catch (e) {}
        resolve({ ok: x.status >= 200 && x.status < 300, json: j });
      };
      x.send(JSON.stringify(body));
    });
  }
  /* the reconciler leaves a fee alone while its case is on the way */
  function markPending(id, on) {
    try {
      var p = JSON.parse(sessionStorage.getItem('gc_logo_pending') || '{}');
      if (on === false) delete p[id]; else p[id] = Date.now();
      sessionStorage.setItem('gc_logo_pending', JSON.stringify(p));
    } catch (e) {}
  }
  var MARK = { Logo: 'Minimalist' };   /* the workshop's value, English in every language */

  /* Find this product's case in the request and tag it. Returns {qty} or null.
     A case that already carries a _logo_id is left as it is (Oct 2026): it has its $25 line already, or
     is on its way back with it (gc-cart-undo.js), and a second id would part the two. */
  function tag(init, id) {
    var body = init && init.body;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (!VARIANTS[String(body.get('id'))] || body.get('properties[_logo_id]')) return null;
      body.append('properties[Logo]', MARK.Logo);
      body.append('properties[_logo_id]', id);
      return { qty: Math.max(1, parseInt(body.get('quantity'), 10) || 1) };
    }
    if (typeof body === 'string' && body.charAt(0) === '{') {
      var j;
      try { j = JSON.parse(body); } catch (e) { return null; }
      var items = j.items || (j.id ? [j] : []);
      var qty = 0;
      items.forEach(function (it) {
        if (!VARIANTS[String(it.id)] || (it.properties && it.properties._logo_id)) return;
        it.properties = Object.assign({}, it.properties || {}, MARK, { _logo_id: id });
        qty += Math.max(1, parseInt(it.quantity, 10) || 1);
      });
      if (!qty) return null;
      init.body = JSON.stringify(j);
      return { qty: qty };
    }
    return null;
  }

  /* 6. "Add all to cart" in the personalize drawer (Oct 2026). personalize-drawer.js sends its whole batch
     in one XMLHttpRequest, which the fetch below never sees; it passes the items array here first
     (GCLogo.tagItems). While the square is ticked, every case of THIS product in it gets "Logo: Minimalist"
     and its own _logo_id, and its own $25 line ({_logo_link}, the case's quantity) goes in at the front:
     fee lines first, as in the add below. One request carries the lot, so the pair arrives together and
     gc-logo-sync.js finds nothing to mend. A saved case of another product is left alone (its photos, too,
     stay as they are), and so is a case that already carries a _logo_id (no second id, no second fee).
     Only this call tags: the cart drawer's old Undo re-add (an XMLHttpRequest in gc-cart-drawer.js) and
     gc-cart-undo.js put lines back exactly as they were. */
  function tagItems(items) {
    if (!on || !items || typeof items.length !== 'number' || !cfg.fee) return 0;
    var fees = [], n = 0;
    items.forEach(function (it) {
      if (!it || !VARIANTS[String(it.id)] || (it.properties && it.properties._logo_id)) return;
      var id = newId() + n;
      it.properties = Object.assign({}, it.properties || {}, MARK, { _logo_id: id });
      fees.push({ id: cfg.fee, quantity: Math.max(1, parseInt(it.quantity, 10) || 1), properties: { _logo_link: id } });
      n++;
    });
    if (fees.length) items.unshift.apply(items, fees);
    return n;
  }

  /* Undo in the cart (gc-cart-undo.js) puts back exactly what was removed and says so with this header:
     a standard case put back while the square here is ticked stays standard, and gets no $25 line */
  function fromUndo(init) {
    var h = init && init.headers;
    if (!h) return false;
    try { return typeof h.get === 'function' ? !!h.get('X-GC-Undo') : !!(h['X-GC-Undo'] || h['x-gc-undo']); } catch (e) { return false; }
  }
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var self = this, args = arguments;
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = String((init && init.method) || 'GET').toUpperCase();
      if (on && method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url) && !fromUndo(init)) {
        var id = newId();
        var t = tag(init, id);
        if (t) {
          markPending(id);
          return xhr('/cart/add.js', { items: [{ id: cfg.fee, quantity: t.qty, properties: { _logo_link: id } }] })
            .then(function (fee) {
              if (!fee.ok) {
                /* no fee, no promise: send the case as a standard one */
                markPending(id, false);
                stripMark(init);
                return nativeFetch.apply(self, args);
              }
              return nativeFetch.apply(self, args).then(function (res) {
                /* the case has arrived (or was refused): the pair is no longer in transit */
                markPending(id, false);
                if (!res.ok) {
                  var key = fee.json && fee.json.items && fee.json.items[0] && fee.json.items[0].key;
                  if (key) xhr('/cart/change.js', { id: key, quantity: 0 });
                }
                return res;
              }, function (err) { markPending(id, false); throw err; });
            });
        }
      }
    } catch (e) {}
    return nativeFetch.apply(this, arguments);
  };
  function stripMark(init) {
    var body = init && init.body;
    try {
      if (body instanceof FormData) { body.delete('properties[Logo]'); body.delete('properties[_logo_id]'); }
      else if (typeof body === 'string' && body.charAt(0) === '{') {
        var j = JSON.parse(body);
        (j.items || [j]).forEach(function (it) { if (it.properties) { delete it.properties.Logo; delete it.properties._logo_id; } });
        init.body = JSON.stringify(j);
      }
    } catch (e) {}
  }
})();
